import React, { FC, SVGProps } from 'react'
import SVGUniqueID from 'react-svg-unique-id'

interface RedCrossFilledIconProps extends SVGProps<SVGSVGElement> {
  width?: number
  height?: number
}

const RedCrossFilledIcon: FC<RedCrossFilledIconProps> = ({
  width = 32,
  height = 32
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_209_898"
        style={{
          maskType: 'alpha'
        }}
        maskUnits="userSpaceOnUse"
        x={2}
        y={2}
        width={28}
        height={28}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.66663 16C2.66663 8.62666 8.62663 2.66666 16 2.66666C23.3733 2.66666 29.3333 8.62666 29.3333 16C29.3333 23.3733 23.3733 29.3333 16 29.3333C8.62663 29.3333 2.66663 23.3733 2.66663 16ZM19.8533 21.7333C20.3733 22.2533 21.2133 22.2533 21.7333 21.7333C22.24 21.2133 22.24 20.36 21.7333 19.8533L17.88 16L21.7333 12.1467C22.2533 11.6267 22.2533 10.7867 21.7333 10.2667C21.2133 9.74666 20.3733 9.74666 19.8533 10.2667L16 14.12L12.1466 10.2667C11.6266 9.74666 10.7866 9.74666 10.2666 10.2667C10.017 10.5158 9.87665 10.854 9.87665 11.2067C9.87665 11.5593 10.017 11.8975 10.2666 12.1467L14.12 16L10.2666 19.8533C10.017 20.1024 9.87665 20.4406 9.87665 20.7933C9.87665 21.146 10.017 21.4842 10.2666 21.7333C10.7866 22.2533 11.6266 22.2533 12.1466 21.7333L16 17.88L19.8533 21.7333Z"
          fill="#0F172A"
        />
      </mask>
      <g mask="url(#mask0_209_898)">
        <rect width={32} height={32} fill="#DC2626" />
      </g>
    </svg>
  </SVGUniqueID>
)
export { RedCrossFilledIcon }
